// ─── User Profile ────────────────────────────────────────────────

export interface IUserProfile {
  user_uuid: string;
  first_name: string;
  last_name: string;
  full_name: string;
  email: string;
  role_value: string;
  role_group?: string;
  mobile?: string | null;
  photo?: string | null;
  status: string;
}

// ─── Company Outlet ──────────────────────────────────────────────

export interface ICompanyOutlet {
  company_outlet_uuid: string;
  company_outlet_name: string;
  policies: string | null;
  remark: string | null;
  logo: string | null;
  status: "ACTIVE" | "INACTIVE";
  company_outlet_address_line1?: string;
  company_outlet_address_line2?: string;
  company_outlet_address_city?: string;
  company_outlet_address_state_or_province?: string;
  company_outlet_address_country?: string;
  company_outlet_address_postal_code?: string;
  company_outlet_region?: string;
  company_outlet_gst_percentage?: number;
  company_outlet_timezone?: string;
  create_ts?: string;
  insert_ts?: string;
}

// ─── WhatsApp Service Info ────────────────────────────────────────

export interface IWhatsAppServiceInfo {
  isMultiple: boolean;
  serviceProviders: string[];
  selectedService: string | null;
  whatsappNumber: string;
}

// ─── Auth Context State ──────────────────────────────────────────

export interface IWhatsAppAuthState {
  user: IUserProfile;
  outlet: ICompanyOutlet;
  whatsappService: IWhatsAppServiceInfo;
  loading: boolean;
  error: string | null;
}

export const defaultUserProfile: IUserProfile = {
  user_uuid: "",
  first_name: "",
  last_name: "",
  full_name: "",
  email: "",
  role_value: "",
  role_group: "",
  mobile: null,
  photo: null,
  status: "ACTIVE",
};

export const defaultCompanyOutlet: ICompanyOutlet = {
  company_outlet_uuid: "",
  company_outlet_name: "",
  policies: null,
  remark: null,
  logo: null,
  status: "ACTIVE",
};

export const initialWhatsAppAuthState: IWhatsAppAuthState = {
  user: defaultUserProfile,
  outlet: defaultCompanyOutlet,
  whatsappService: {
    isMultiple: false,
    serviceProviders: [],
    selectedService: null,
    whatsappNumber: "",
  },
  loading: true,
  error: null,
};
